import ScrapingRed  from '../../../assets/scraping-red.svg?react'
import Close from '../../../assets/close.svg?react'
import styles from '../Scraping/Scraping.module.css'
import { getActiveGeocontext } from '../../../utils'
import {
  useLastOSMStatusGeocontext,
  useStartOSM,
  useStopOSM,
} from '../../../hooks/geocontext'
import { useEffect } from 'react'
import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'

export default function ScrapingOsm({
  scrapingOsmOpen,
  setScrapingOsmOpen,
}: {
  scrapingOsmOpen: boolean
  setScrapingOsmOpen: (value: boolean) => void
}) {
  const { t } = useTranslation()
  const activeGeocontext = getActiveGeocontext()
  const lastOSM = useLastOSMStatusGeocontext(activeGeocontext?.id || 0)
  const {
    mutateAsync: startOSM,
    isLoading: isStartScrapingLoading,
    error: startScrapingError,
  } = useStartOSM(activeGeocontext?.id || 0)

  const {
    mutateAsync: stopOSM,
    isLoading: isStopScrapingLoading,
    error: stopScrapingError,
  } = useStopOSM(activeGeocontext?.id || 0)

  //polling
  useEffect(() => {
    const interval = setInterval(() => {
      lastOSM.refetch()
    }, 8000)
    return () => clearInterval(interval)
  }, [])

  return (
    <div
      className={styles.ScrapingOverlay}
      role="dialog"
      aria-modal="true"
      onClick={close}
    >
      <div className={styles.ScrapingModal}>
        <div className="w-100 h-100 d-flex justify-content-center position-relative">
          <div
            className={styles.HomeContent}
            style={{
              width: 532,
              transition: 'width 0.3s ease-in-out',
            }}
          >
            <div
              className={styles.Close}
              onClick={() => setScrapingOsmOpen(false)}
            >
              <Close />
            </div>
            <div className={styles.Title}>
              <ScrapingRed className="me-2" /> Scraping Osm
            </div>

            {/* Last OSM run */}
            {!!lastOSM.data?.last_osm_update && (
              <>
                <div className="d-flex flex-column justify-content-between mt-4">
                  <div className={styles.Desc}>
                    {t('LAST_OSM_PERFORMED_ON')}{' '}
                    {dayjs(lastOSM.data?.last_osm_update).format(
                      'DD/MM/YYYY HH:mm'
                    )}
                  </div>
                </div>
              </>
            )}

            {/* Never run OSM */}
            {!!lastOSM.data && !!!lastOSM.data?.last_osm_update && (
              <div className="d-flex align-items-center justify-content-between mt-4">
                <div className={styles.Desc}>{t('NO_OSM_DONE')} </div>
              </div>
            )}

            {/* Running osm: show stop button and status */}
            {!!lastOSM.data?.last_osm_started && (
              <>
                <div className="d-flex flex-column justify-content-between mt-4">
                  <div className={styles.Desc}>
                    {t('LAST_SCRAPING_RUNNING_STARTED')}{' '}
                    {dayjs(lastOSM.data?.last_osm_started).format(
                      'DD/MM/YYYY HH:mm'
                    )}
                  </div>
                  <div className={styles.Desc}>
                    {t('LAST_SCRAPING_RUNNING_STATUS')}{' '}
                    {lastOSM.data?.last_osm_update_status}
                  </div>
                </div>

                <div className="w-100 mt-2">
                  <button
                    className="btn btn-danger w-100 btn-sm"
                    disabled={isStopScrapingLoading}
                    onClick={() => stopOSM().then(() => lastOSM.refetch())}
                  >
                    {t('STOP_OSM')}
                  </button>
                </div>
              </>
            )}

            {/* not started osm and not queued */}
            {!!!lastOSM.data?.last_osm_started &&
              !!!lastOSM.data?.last_osm_queued && (
                <>
                  <div className="d-flex align-items-center justify-content-between mt-4">
                    <div className={styles.Desc}>{t('NO_OSM_RUNNING')} </div>
                  </div>

                  {!!lastOSM.data?.last_osm_update_error && (
                    <>
                      <div className={styles.Desc}>{t('OSM_LAST_ERROR')} </div>
                      <div className="text-danger mt-2">
                        {lastOSM.data?.last_osm_update_error}
                      </div>
                    </>
                  )}

                  <div className="w-100 mt-2">
                    <button
                      className="btn btn-danger btn-sm w-100"
                      disabled={isStartScrapingLoading}
                      onClick={() => startOSM().then(() => lastOSM.refetch())}
                    >
                      {t('START_OSM')}
                    </button>
                  </div>
                </>
              )}

            {/* task is queued */}
            {!!!lastOSM.data?.last_osm_started &&
              lastOSM.data?.last_osm_queued && (
                <>
                  <div className="d-flex align-items-center justify-content-between mt-4">
                    <div className={styles.Desc}>{t('OSM_QUEUED')} </div>
                  </div>

                  <div className="w-100 mt-2">
                    <button
                      className="btn btn-danger w-100 btn-sm"
                      disabled={isStopScrapingLoading}
                      onClick={() => stopOSM().then(() => lastOSM.refetch())}
                    >
                      {t('STOP_OSM')}
                    </button>
                  </div>
                </>
              )}
          </div>
        </div>
      </div>
    </div>
  )
}
